import { StoreApi } from 'zustand';

import { TTextLocalized, ISelectOption } from '@northladder/utilities';

import { IDateRangeType } from '../../../types';

import { TSortDirection } from '../../bids/types';

export interface IDealsScreenFilterOption {
  label: TTextLocalized;
  value: string;
}

/**
 * Category type received from the API response.
 */
export interface ICategoryData {
  checked: boolean;
  description?: string;
  id: string;
  title: TTextLocalized;
  titleStr: string;
}

/**
 * Sort options enum for deals list table
 */
export enum EDealsSortByOptions {
  CATEGORY_NAME = 'categoryName',
  SERIAL_NUMBER = 'serialNumber',
  CONDITION = 'condition',
  PURCHASE_PRICE = 'purchasePrice',
  DELIVERY_DATE = 'deliveryDate',
}

export interface IDealsFilterState {
  /**
   * The current active search key for the bids page.
   */
  searchKey: string;
  onUpdateDealsSearchKey: (searchKey: string) => void;
  /**
   * selected range of date
   */
  dateRange: IDateRangeType | null;
  /**
   * selected search filter type
   */
  searchTypeFilter: IDealsScreenFilterOption;
  /**
   * to update `dealsDateRange`
   */
  onUpdateDealsDateRange: (dateRange: IDateRangeType | null) => void;
  /**
   * List of all active filters
   */
  selectedDealsFilters: IDealsScreenFilterOption[];
  /**
   * To update `selectedDealsFilters`
   */
  updateSelectedFilters: (filters: IDealsScreenFilterOption[]) => void;
  /**
   * To update `searchTypeFilter`
   */
  onUpdateSearchTypeFilter: (
    searchTypeFilter: IDealsScreenFilterOption
  ) => void;
  /**
   * Selected category filter
   */
  selectedCategory: ICategoryData | null;
  /**
   * To update `selectedCategory`
   */
  onUpdateSelectedCategory: (category: ICategoryData | null) => void;
  /**
   * Selected brand filters
   */
  selectedBrands: ISelectOption[];
  /**
   * To update `selectedBrands`
   */
  onUpdateSelectedBrands: (brands: ISelectOption[]) => void;
  /**
   * Selected asset group filters
   */
  selectedAssetGroups: ISelectOption[];
  /**
   * To update `selectedAssetGroups`
   */
  onUpdateSelectedAssetGroups: (assetGroups: ISelectOption[]) => void;
  /**
   * Sort by field for deals list
   */
  sortBy: EDealsSortByOptions | null;
  /**
   * Update sort by field
   */
  updateSortBy: (sortBy: EDealsSortByOptions | null) => void;
  /**
   * Order by direction for deals list
   */
  orderBy: TSortDirection | null;
  /**
   * Update order by direction
   */
  updateOrderBy: (orderBy: TSortDirection | null) => void;
  /**
   * Column visibility state for deals list table
   */
  dealsListTableColumnVisibility: Record<string, boolean>;
  /**
   * Update column visibility state for deals list table
   */
  updateDealsListTableColumnVisibility: (
    visibility: Record<string, boolean>
  ) => void;
  /**
   * Page size for deals list table
   */
  dealsListTablePageSize: number;
  /**
   * Update page size for deals list table
   */
  updateDealsListTablePageSize: (pageSize: number) => void;
  /**
   * Whether the filters dialog is visible
   */
  isFiltersDialogVisible: boolean;
  /**
   * Update whether the filters dialog is visible
   */
  onUpdateIsFiltersDialogVisible: (visible: boolean) => void;
  /**
   * Whether the filters dialog is pinned (sidebar mode)
   */
  isFiltersDialogPinned: boolean;
  /**
   * Update whether the filters dialog is pinned
   */
  onUpdateIsFiltersDialogPinned: (pinned: boolean) => void;
  /**
   * Width of the filter sidebar in pixels
   */
  filterSidebarWidth: number;
  /**
   * Update the filter sidebar width
   */
  updateFilterSidebarWidth: (width: number) => void;
  /**
   * clears all deals filter.
   */
  clearDealsStore: () => void;
}

export type TSetDealsFilters = StoreApi<IDealsFilterState>['setState'];
